// Treasury wallets-directory parser — DTO (wire shape) → view model.
// The seam every consumer must respect. Containers / components /
// composables never read a snake_case field directly.

import type {
  WalletDirectoryRowDto,
  WalletsDirectoryListResponseDto,
} from './walletsDirectoryContracts'
import type {
  WalletDirectoryRow,
  WalletsDirectoryListResponse,
} from '../types/walletsDirectoryTypes'

export function parseWalletDirectoryRow(dto: WalletDirectoryRowDto): WalletDirectoryRow {
  return {
    id: String(dto.id ?? ''),
    investorId: String(dto.investorId ?? dto.investor_id ?? ''),
    investorName: String(dto.investorName ?? dto.investor_name ?? ''),
    investorEmail: String(dto.investorEmail ?? dto.investor_email ?? ''),
    kycStatus: dto.kycStatus ?? dto.kyc_status ?? null,
    totalBalance: String(dto.totalBalance ?? dto.total_balance ?? '0'),
    availableBalance: String(dto.availableBalance ?? dto.available_balance ?? '0'),
    lockedBalance: String(dto.lockedBalance ?? dto.locked_balance ?? '0'),
    currencyCode: String(dto.currencyCode ?? dto.currency_code ?? ''),
    updatedAt: String(dto.updatedAt ?? dto.updated_at ?? ''),
    createdAt: String(dto.createdAt ?? dto.created_at ?? ''),
  }
}

export function parseWalletsDirectoryListResponse(
  dto: WalletsDirectoryListResponseDto,
): WalletsDirectoryListResponse {
  const limit = Number(dto.meta?.limit ?? 0)
  const total = Number(dto.meta?.total ?? 0)
  const page = Number(dto.meta?.page ?? 1)
  const totalPagesRaw = dto.meta?.totalPages ?? dto.meta?.total_pages
  const totalPages =
    totalPagesRaw !== undefined && totalPagesRaw !== null
      ? Number(totalPagesRaw)
      : limit > 0
        ? Math.ceil(total / limit)
        : 0
  return {
    data: (dto.data ?? []).map(parseWalletDirectoryRow),
    meta: { total, page, limit, totalPages },
  }
}
